import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from 'primereact/button';
import usePreferredLanguage from '../utilities/usePreferredLanguage';
import { translateUiText } from '../utilities/siteTranslations';

export const Error = (props) => {
    const navigate = useNavigate();
    const preferredLanguage = usePreferredLanguage();
    const t = (value) => translateUiText(value, preferredLanguage);

    const goDashboard = () => {
        navigate('/');
    };

    return (
        <div className="exception-body error">
            <div className="exception-panel">
                <h1>{t('ERROR')}</h1>
                <h3>{t("something's went wrong")}</h3>
                <Button type="button" label={t('Go back to home')} onClick={goDashboard}></Button>
            </div>
            <div className="exception-footer">
                <img src={`assets/layout/images/logo-${props.colorScheme === 'light' ? 'dark' : 'light'}.png`} className="exception-logo" alt="exception-logo" />
                <img src={`assets/layout/images/appname-${props.colorScheme === 'light' ? 'dark' : 'light'}.png`} className="exception-appname" alt="exception-appname" />
            </div>
        </div>
    );
};
